export default __webpack_public_path__ + "static/identifying-drop-offs-light-mode-3fecbb97c4db9d7018ad74372dd5fdac.png";